import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";

  switch (params.trip) {
    case "May-2027":
      dates = "May 4 - 15, 2027";
      break;
    case "trip":
      dates = "";
      break;
  }
  return (
    <div className={styles.backgroundPictureGermany}>
      <div className={styles.titleBox}>
        <h1 className={styles.intro}>
          Come and explore the history of the events that changed the world.
        </h1>
        <p className={styles.title}>Germany</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            Berlin, Wittenberg, the Castle of Wartburg, Erfurt, Augsburg, the
            beauty of the Bavarian Alps, and much more.{" "}
          </p>
          <p>
            Discover the significant places and history of Martin Luther's life
            and the Protestant Reformation. Visit the home of Dietrich
            Bonhoeffer and the concentration camp where he was executed.
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
